import { Directive, HostListener, HostBinding } from "@angular/core";

@Directive({
  selector: "[mat-filter-item]",
})
export class MatFilterItemDirective {
  @HostListener("click", ["$event"])
  onClick(e: MouseEvent) {
    console.log("clicou aqui");
    e.stopPropagation();
    e.preventDefault();
    return false;
  }
}
